<template>
  <div
    v-if="assetTrayGrouping && assetTrayTabs.length > 0"
    id="asset-tray"
    class="asset-tray"
  >
    <div
      class="asset-tray-tabs"
    >
      <button
        v-for="(tab) in assetTrayTabs"
        :key="'button-'+tab.id"
        class="asset-tray-tab"
        :class="{ 'active': tab.id === activeTabId }"
        @click="activeTabId = tab.id"
      >
        <span v-html="tab.buttonTitle"></span>
        <icon
          v-if="tab.newContent"
          name="circle-filled"
          variant="DC3416"
        />
      </button>
    </div>
    <div
      class="active-tab-container"
    >
      <div
        v-for="tab in assetTrayTabs"
        :key="tab.id"
        class="asset-tray-content"
        :class="{ visible: tab.id === activeTabId }"
      >
        <div
          v-for="subTopic in tab.subTopics"
          :key="subTopic.id"
          class="asset-tray-subtopic"
        >
          <p class="subtopic-title">
            <span v-html="subTopic.title"></span>
          </p>
          <div v-html="subTopic.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssetTrayMixin from '@/mixins/asset-tray';
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  mixins: [AssetTrayMixin],
  props: {
    flashcard: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>

.asset-tray {
  margin-bottom: rem-calc(24);
}
.active-tab-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  font-size: rem-calc(16);
  line-height: rem-calc(24);

  .asset-tray-content {
    grid-column-start: 1;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 2;

    opacity: 0;
    transition: opacity 0.3s ease-in-out;

    &.visible {
      opacity: 1;
    }
  }

  .subtopic-title {
    font-weight: 600;
    color: rgba(35, 35, 35, 1);
  }
}

.asset-tray-tabs {
  background-color: #F8FAFC;
  border: 1px solid #E3E8EF;
  border-radius: rem-calc(12);
  display: flex;
  flex-wrap: wrap;
  padding: rem-calc(4);
  gap: rem-calc(8);

  .asset-tray-tab {
    font-size: rem-calc(14);
    line-height: rem-calc(20);
    font-weight: 600;
    color: #697586;
    padding: rem-calc(12) rem-calc(16);
    background-color: transparent;
    border: 1px solid transparent;
    display: flex;
    align-items: center;
    gap: rem-calc(8);

    &.active {
      background-color: white;
      border: 1px solid #E3E8EF;
      border-radius: rem-calc(8);
      color: #364152;
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.06);
      box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
    }
  }
}
</style>
